module.exports = __webpack_public_path__ + "static/media/seat_8.f6b30f69.png_bc";